jQuery(document).ready(function($){
    setInterval(function () {
      jQuery('.product-grid.bottom.owl-carousel').owlCarousel({
        loop:false,
        margin:30,
        nav:true,
        dots:false,
        responsive:{
          0:{
            items:1
          },
          600:{
            items:2
          },
          1000:{
            items:3
          },
          1280: {
            items:4
          }
        }
      })
    }, 1500);
  
});

jQuery(document).ready(function(){
    var $temp = $("<input>");
    var $url = $(location).attr('href');
    $('.copy-link #btn').click(function() {
    $("body").append($temp);
    $temp.val($url).select();
    document.execCommand("copy");
    $temp.remove();
    $(".copy-link p").text("URL copied!");
    });
  
  
  	$('.template-product .quantity__input[type=number]').on('change', function() {
      if($(this).val() == 0) {
          $(this).val('1');
      }
	});
});

